import {TripNodeActivityCd} from '../';
import {EnumHelper} from './enum-helper';

export class TripNodeActivityCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in TripNodeActivityCd ) {
      this._values.push(TripNodeActivityCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): TripNodeActivityCd {

    for ( const obj in TripNodeActivityCd ) {
      if (TripNodeActivityCd[obj] === value){
        return TripNodeActivityCd[obj] as TripNodeActivityCd;
      }
    }
  }
}

const TripNodeActivityCdHelper = new TripNodeActivityCdHelperEnumHelperClass();
export default TripNodeActivityCdHelper;
